import { useNavigate, useSearchParams } from "react-router-dom"
import { SetAcceptNewDevice } from "../../services/UserServices"
import { IAcceptDeviceVO } from "../../model/UserModel"
import { useTranslation } from "react-i18next"

const AddNewDevice = () => {
    const [searchParams] = useSearchParams()
    const email = searchParams.get('email')
    const deviceToken = searchParams.get('deviceToken')
    const navigator = useNavigate();
    const { t } = useTranslation();

    async function acceptedTrustedDevice(input: IAcceptDeviceVO) {

        try {
            await SetAcceptNewDevice(input);
            navigator("/login");
        } catch {

        }
    }

    return (
        <>
            <div style={{ margin: 0, padding: 0, fontFamily: 'Arial, Helvetica, sans-serif', color: '#2D2D2D' }}>
                <div style={{ padding: '32px 40px' }}>
                    <table
                        style={{
                            width: '100%',
                            margin: 0,
                            maxWidth: '600px',
                            border: '1px solid #D2E0E8',
                            overflow: 'hidden',
                            backgroundColor: '#ffffff',
                        }}
                    >
                        <tr>
                            <th
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '71px',
                                    borderBottom: '1px solid #D2E0E8',
                                }}
                            >
                                <div
                                    style={{
                                        width: '130px',
                                        height: '18px',
                                        backgroundImage: 'url(http://localhost:3000/iconmail.png)',
                                        backgroundSize: '130px 18px',
                                    }}
                                ></div>
                            </th>
                        </tr>
                        <tr>
                            <th>
                                <div style={{ padding: '30px 40px' }}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            backgroundImage: 'url(http://localhost:3000/bgkeys_device.png)',
                                            backgroundSize: '100% 120px',
                                            height: '120px',
                                            backgroundColor: '#e9eff4',
                                        }}
                                    ></div>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                        <h3
                                            style={{
                                                padding: '30px 0',
                                                font: 'normal normal bold 20px/30px Arial',
                                                color: '#2D2D2D',
                                                margin: 0,
                                            }}
                                        >
                                            {t("AddNewDevice.NewDeviceDetectedTitle")}
                                        </h3>

                                        <p
                                            style={{
                                                font: 'normal normal normal 16px/24px Arial',
                                                textAlign: 'left',
                                                color: '#2D2D2D',
                                                margin: '12px 0 30px',
                                            }}
                                        >
                                            {t("AddNewDevice.NewDeviceDetectedContent")}
                                        </p>
                                        <a
                                            style={{
                                                background: '#22638D 0% 0% no-repeat padding-box',
                                                color: '#FFFFFF',
                                                textDecoration: 'none',
                                                padding: '7.5px 12px',
                                                borderRadius: '4px',
                                                font: 'normal normal normal 16px / 21px Segoe UI',
                                                alignSelf: 'center',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                if (email != undefined && deviceToken != undefined) {
                                                    let input: IAcceptDeviceVO = {
                                                        email,
                                                        deviceToken
                                                    }
                                                    
                                                    acceptedTrustedDevice(input);
                                                }
                                            }}
                                        >
                                            {t("AddNewDevice.AuthorizeDevice")}
                                        </a>
                                    </div>
                                </div>
                            </th>
                        </tr>
                        <tr>
                            <th style={{ padding: '20px 0', borderTop: '1px solid #d2e0e8' }}>
                                <p
                                    style={{
                                        textAlign: 'center',
                                        font: 'normal normal normal 12px/18px Arial',
                                        color: '#747474',
                                        margin: 0,
                                    }}
                                >
                                    {t("AddNewDevice.MessagedSentFor")}
                                </p>
                                <p
                                    style={{
                                        textAlign: 'center',
                                        font: 'normal normal normal 12px/18px Arial',
                                        color: '#747474',
                                        marginTop: '5px',
                                    }}
                                >
                                    {t("AddNewDevice.Bom")}
                                </p>
                            </th>
                        </tr>
                    </table>
                </div>
            </div>

        </>
    )
}

export default AddNewDevice

